(() => {
  if (customElements.get('vg-announcement')) return;

  class VgAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-vg-announcement-slide]'));
      this.toggle = this.querySelector('[data-vg-announcement-toggle]');
      this.header = this.closest('[data-vg-header]');
      this.index = 0;
      this.paused = false;
      this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== 0)));

      this.onToggle = () => {
        this.paused = !this.paused;
        this.updateToggle();
        this.schedule();
      };
      this.onVisibility = () => this.schedule();
      this.measure = () => {
        const height = this.header?.getBoundingClientRect().height;
        if (height) document.body.style.setProperty('--vg-header-height', `${Math.ceil(height)}px`);
      };
      this.toggle?.addEventListener('click', this.onToggle);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('resize', this.measure);
      if ('ResizeObserver' in window && this.header) {
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.header);
      }
      this.updateToggle();
      this.measure();
      this.schedule();
    }

    updateToggle() {
      if (!this.toggle) return;
      this.toggle.hidden = this.slides.length < 2;
      this.toggle.setAttribute('aria-label', this.paused ? (this.getAttribute('data-resume-label') || 'Resume announcements') : (this.getAttribute('data-pause-label') || 'Pause announcements'));
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }

    schedule() {
      clearInterval(this.timer);
      if (this.paused || document.hidden || this.slides.length < 2) return;
      this.timer = setInterval(() => {
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.index = (this.index + 1) % this.slides.length;
        this.slides[this.index].setAttribute('aria-hidden', 'false');
      }, 7000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.toggle?.removeEventListener('click', this.onToggle);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('resize', this.measure);
    }
  }

  customElements.define('vg-announcement', VgAnnouncement);
})();
